/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED API METHODS - DO NOT EDIT
 * Generated from: MerchantTransactionsContract
 */

import { apiClient } from '../../utils/api-client';
import { toIsoString } from '@zlinkx/shared-v2';
import type {
  ListTransactionsParamsType,
  ListTransactionsQueryType,
  ListTransactionsResponseType,
  MessageResponse,
} from '@zlinkx/shared-v2';

type SerializableQueryValue =
  | string
  | number
  | boolean
  | Array<string | number | boolean>;

function serializeQueryValue(value: unknown): string | number | boolean | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (value instanceof Date) {
    return toIsoString(value);
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }

  return String(value);
}

function serializeQueryParams(params?: Record<string, unknown>): Record<string, SerializableQueryValue> | undefined {
  if (!params) {
    return undefined;
  }

  const serialized: Record<string, SerializableQueryValue> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      const arrayValues = value
        .map(item => serializeQueryValue(item))
        .filter((item): item is string | number | boolean => item !== undefined);

      if (arrayValues.length > 0) {
        serialized[key] = arrayValues;
      }
      return;
    }

    const scalarValue = serializeQueryValue(value);
    if (scalarValue !== undefined) {
      serialized[key] = scalarValue;
    }
  });

  return Object.keys(serialized).length > 0 ? serialized : undefined;
}

export const merchanttransactionsApi = {
  listTransactions: async (
    merchantId: ListTransactionsParamsType['merchantId'],
    params?: ListTransactionsQueryType
  ): Promise<ListTransactionsResponseType> => {
    return apiClient.get<ListTransactionsResponseType['data']>(`/merchants/${merchantId}/transactions`, { params: serializeQueryParams(params) }) as Promise<ListTransactionsResponseType>;
  },
};